// apps/canifight/src/App.jsx
import { useState } from "react";
import { AuthProvider, useAuth } from "./firebase/useAuth";
import { SavePromptModal } from "./firebase/SavePromptModal";
import Landing from "./screens/Landing";
import Survey from "./screens/Survey";
import Roster from "./screens/Roster";
import Matchup from "./screens/Matchup";
import StatsPanel from "./components/StatsPanel";
import InstallBanner from "./components/InstallBanner";
import { DEFAULT_USER_STATS, STAT_KEYS } from "./data/fighters";
import "./index.css";

function CanIFightIt() {
  const { user, isAnonymous, saveData, loadData } = useAuth();
  const [screen, setScreen] = useState("landing");
  const [userStats, setUserStats] = useState(DEFAULT_USER_STATS);
  const [selectedFighter, setSelectedFighter] = useState(null);
  const [showStatsPanel, setShowStatsPanel] = useState(false);
  const [showSaveModal, setShowSaveModal] = useState(false);

  const handleSurveyComplete = (stats) => {
    setUserStats(stats);
    setScreen("roster");
  };

  const handleSkipSurvey = () => {
    setUserStats(DEFAULT_USER_STATS);
    setScreen("roster");
  };

  const handleSelectFighter = (idx) => {
    setSelectedFighter(idx);
    setScreen("matchup");
  };

  const handleSave = async () => {
    if (isAnonymous) {
      setShowSaveModal(true);
    } else {
      await saveData("canifight", { userStats });
    }
  };

  const handleAccountCreated = async () => {
    await saveData("canifight", { userStats });
  };

  return (
    <div>
      {screen === "landing" && (
        <Landing onStart={() => setScreen("survey")} onSkip={handleSkipSurvey} />
      )}
      {screen === "survey" && (
        <Survey onComplete={handleSurveyComplete} />
      )}
      {screen === "roster" && (
        <Roster
          userStats={userStats}
          onSelectFighter={handleSelectFighter}
          onViewStats={() => setShowStatsPanel(true)}
        />
      )}
      {screen === "matchup" && selectedFighter !== null && (
        <Matchup
          userStats={userStats}
          fighterIdx={selectedFighter}
          onBack={() => setScreen("roster")}
          onSave={handleSave}
        />
      )}

      {showStatsPanel && (
        <StatsPanel
          userStats={userStats}
          statKeys={STAT_KEYS}
          onClose={() => setShowStatsPanel(false)}
          onRetake={() => { setShowStatsPanel(false); setScreen("survey"); }}
        />
      )}

      {showSaveModal && (
        <SavePromptModal
          onClose={() => setShowSaveModal(false)}
          onSuccess={handleAccountCreated}
        />
      )}

      <InstallBanner />
    </div>
  );
}

export default function App() {
  return (
    <AuthProvider>
      <CanIFightIt />
    </AuthProvider>
  );
}
